<button
  class="flex h-fit w-full items-center justify-center gap-8 overflow-hidden p-12 text-body-md-400 text-secondary-greys-white disabled:bg-secondary-greys-300 disabled:text-secondary-greys-30"
  (click)="buttonClicked.emit(true)"
  [disabled]="disabled()"
  [ngClass]="{
    'bg-brand-900 hover:bg-brand-800 active:bg-brand-950': type() === 'default',
    'bg-secondary-crimson-900 hover:bg-secondary-crimson-800 active:bg-secondary-crimson-950': type() === 'negative'
  }"
>
  {{ label() }}
</button>
